import {useHistory, useParams} from 'react-router-dom'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useDispatch} from 'react-redux'
import axios from 'axios'
import {MoonLoader} from 'react-spinners'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import { WOUND_ENTRIES_LISTING_COLOUMS  , WOUND_ENTRIES_DATA_MAPPING,WOUND_ENTRIES_SORTING_DATA,} from '../../../wound/WOUND_TABLE_CONSTANTS'
import { QueryData } from '../../../../reusable-components/tables/DynamicTableTypes'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import {toast} from 'react-toastify'
import { hasPermission } from '../../../../../_helper/hasPermission'
import { permissions } from '../../../../../_constants/permissions'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import { RootState } from '../../../../../setup'

const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedWoundCareNote = () => {
  const {clientId, id}: {clientId: string; id: string} = useParams()
  const [isFetchingData, setIsFetchingData] = useState(false)
  const [loadingStates, setLoadingStates] = useState({})
  const [searchTerm, setSearchTerm] = useState('')
  const dispatch = useDispatch()
  const timeZone = useSelector(selectTimeZone)
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const [filteredData, setFilteredData] = useState<any[]>([])
  const history = useHistory()
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
    const [fullData, setFullData] = useState<any[]>([])
   useEffect(() => {
    const fetchData = async () => {
      
      setIsFetchingData(true);
      try {
        const response = await axios.get(`/wound-entries/getByClientId/${clientId}`, {
          params: {
            page: queryData.pageNumber,
            pageSize: queryData.pageSize,
            sortBy: queryData.sortBy,
            sortDir: queryData.sortDir,
            searchTerm: queryData.searchTerm,
            woundId: id, 
            isDeleted: true,
          },
        });
        console.log(response.data)
        
        
        const { data, currentPage, totalCounts } = response.data;
        setFullData(data);
        setFilteredData(data);
        setQueryData(prev => ({
          ...prev,
          currentPage,
          totalCounts,
        }));
      } catch (error) {
        console.error('Error fetching wound care entries:', error);
        toast.error('Failed to fetch wound entries');
      } finally {
        setIsFetchingData(false);
      }
    };

    fetchData();
  }, [clientId, id, queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm]);
  const handleUpdate = (row: any) => {
    history.push(`/deleted-notes/wound-care-notes/entry/clientId=${clientId}/woundId=${id}/entryId=${row._id}`)
  }
  return (
    <div className='card'>
      <div className='card-body'>
        {isFetchingData ? (
          <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
            <MoonLoader color='#9db2fc' size={60} loading={isFetchingData} />
          </div>
        ) : (
          <div>
            <TableTitle title='Deleted Wound Care Entries' />
            <TableWrapper
              searchField={
                hasPermission(
                  userPermissions,
                  permissions.notes_occupational_therapy_note_search
                ) && (
                  <TableSearchBar
                    label='Search'
                    variant='outlined'
                    size='small'
                    value={searchTerm}
                    setQueryData={setQueryData}
                    setSearchTerm={setSearchTerm}
                    margin='normal'
                    inputAdornmentPosition='start'
                  />
                )
              }
              dynamicTable={
                <DynamicTable
                  columns={WOUND_ENTRIES_LISTING_COLOUMS}
                  data={filteredData}
                  canUpdate={true}
                  onUpdate={handleUpdate}
                  columnDataMapping={WOUND_ENTRIES_DATA_MAPPING}
                  sortingColumns={WOUND_ENTRIES_SORTING_DATA}
                  clickableRow={false}
                  loadingStates={loadingStates}
                  setQueryData={setQueryData}
                  queryData={queryData}
                />
              }
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DeletedWoundCareNote
